<ng-template #template id="modal-1">
    <div class="centered-content call-me-back-hm">
        <div nxLayout="grid" *ngIf="!formBEValid">
            <div nxRow>
                <div nxCol="12" style="text-align: center;">
                    <h3 nxHeadline="subsection-medium" class="disclaimer__headline" translate>callMeBack.title</h3>
                    <p nxCopytext translate>callMeBack.text</p>
                </div>
            </div>
            <form [formGroup]="form" (submit)="submit($event)" autocomplete="off">

                <div nxRow>
                    <div nxCol="12,12,8,8" colOffset="0,0,2,2">
                        <nx-formfield label="{{ 'callMeBack.dateFieldLabel' | translate }}">
                            <input nxDatefield nxInput [datepicker]="dateDatepicker" [datefieldFilter]="filterDate"
                                formControlName="date" [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']" displayFormat="DD.MM.YYYY"
                                (ngModelChange)="timeBind()" />

                            <nx-datepicker-toggle [for]="dateDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
                            <nx-datepicker #dateDatepicker></nx-datepicker>
                            <nx-error nxFormfieldError *ngIf="form.get('date')?.errors?.valid == false" translate>
                                <span translate>callMeBack.invalidField</span>
                            </nx-error>
                            <nx-error nxFormfieldError *ngIf="form.get('date')?.errors?.history" translate>
                                <span translate>callMeBack.historyField</span>
                            </nx-error>
                            <nx-error nxFormfieldError *ngIf="form.get('date')?.errors?.future" translate>
                                <span translate>callMeBack.futureField</span>
                            </nx-error>
                            <nx-error nxFormfieldError *ngIf="form.get('date')?.errors?.holiday" translate>
                                <span translate>callMeBack.holidayField</span>
                            </nx-error>
                        </nx-formfield>
                    </div>
                </div>
                
                <div nxRow>
                    <div nxCol="12,12,8,8" colOffset="0,0,2,2">
                        <nx-formfield label="{{ 'callMeBack.hourFieldLabel' | translate }}">
                            <nx-dropdown formControlName="hour">
                                <ng-template ngFor let-hourData="$implicit" [ngForOf]="hourDataArray">
                                    <nx-dropdown-item value="{{hourData}}"></nx-dropdown-item>
                                </ng-template>
                            </nx-dropdown>
                            <nx-error nxFormfieldError *ngIf="form.get('hour')?.errors?.valid == false" translate>
                                <span translate>callMeBack.invalidField</span>
                            </nx-error>
                            <nx-error nxFormfieldError *ngIf="form.get('hour')?.errors?.history" translate>
                                <span translate>callMeBack.historyField</span>
                            </nx-error>
                        </nx-formfield>
                    </div>
                </div>
                <div nxRow>
                    <div nxCol="12,12,8,8" colOffset="0,0,2,2">
                        <nx-checkbox formControlName="agreement">
                            <span translate>callMeBack.agreementFieldText</span><br>
                        </nx-checkbox>
                        <nx-error *ngIf="form.get('agreement')?.errors?.required">
                            <span translate>callMeBack.requiredField</span>
                        </nx-error>
                    </div>
                </div>
                <div nxRow>
                    <div nxCol="12,12,8,8" colOffset="0,0,2,2" style="text-align: center;">
                        <button nxButton="primary medium" type="submit" [disabled]="this.form.valid ? null : ''"><span
                                translate>callMeBack.submitBtnText</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <div nxLayout="grid" *ngIf="formBEValid">
            <div nxRow>
                <div nxCol="12" style="text-align: center;">
                    <p nxCopytext translate>callMeBack.successText</p>
                </div>
            </div>
        </div>
    </div>
</ng-template>
